<template>
  <img v-bind:src="'/static/icons/'+icon+'.svg'" v-bind:style="_style" />
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    width : {type: String, default: "auto"},
    height: {type: String, default: "auto"},
    icon  : {type: String, default: "star"}
  },
  computed: {
    _style : function(){
      return {
        width:  this.width,
        height: this.height,
      }
    }
  },

}
</script>



// WEBPACK FOOTER //
// src/components/SvgIcon.vue